import { render, staticRenderFns } from "./PendingTasks.vue?vue&type=template&id=a504a6fc&scoped=true&lang=pug"
import script from "./PendingTasks.vue?vue&type=script&lang=js"
export * from "./PendingTasks.vue?vue&type=script&lang=js"
import style0 from "./PendingTasks.vue?vue&type=style&index=0&id=a504a6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a504a6fc",
  null
  
)

export default component.exports